import { useCallback } from 'react'
import { toast } from 'sonner'
import type { Player } from '@/types/turn'

interface UseTurnControlsProps {
  startTurn: (playerIds: string[], timeLimit: number) => Promise<void>
  startCountdown: () => Promise<void>
}

/**
 * Os dois comandos do mestre que passam por aqui: abrir a rodada e retomar a
 * contagem depois de uma pausa.
 *
 * Já foi maior. O estado local "configurado mas não iniciado" (`configuredTurn`)
 * morreu na fase 2 e a fiação dele saiu na fase 4, junto com a tela antiga.
 * Quem sabe se a rodada já está correndo é o servidor — a tela lê o estado que
 * ele manda, em vez de guardar um palpite próprio.
 */
export function useTurnControls({ startTurn, startCountdown }: UseTurnControlsProps) {
  const handleStartTurn = useCallback(async (config: { playerOrder: Player[], timeLimit: number }) => {
    const playerIds = config.playerOrder.map(player => player.id)

    try {
      await startTurn(playerIds, config.timeLimit)
    } catch (error) {
      // Falha de ENVIO (socket fechado). A recusa do servidor é outra coisa e
      // chega pelo aviso do useTurnControl — este `catch` não a vê, porque a
      // mensagem sai sem resposta correlacionada.
      console.error('[GAME] Erro ao abrir a rodada:', error)
      toast.error('Não deu para falar com o servidor. Tente de novo.')
    }
  }, [startTurn])

  const handleStartCountdown = useCallback(async () => {
    try {
      await startCountdown()
    } catch (error) {
      console.error('[GAME] Erro ao iniciar contagem:', error)
    }
  }, [startCountdown])

  return {
    handleStartTurn,
    handleStartCountdown
  }
}
